import { render, staticRenderFns } from "./AllServiceRequest.vue?vue&type=template&id=663bc856&scoped=true&"
import script from "./AllServiceRequest.vue?vue&type=script&lang=js&"
export * from "./AllServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./AllServiceRequest.vue?vue&type=style&index=0&id=663bc856&prod&lang=scss&scoped=true&"
import style1 from "./AllServiceRequest.vue?vue&type=style&index=1&id=663bc856&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bc856",
  null
  
)

export default component.exports